<template>
  <div class="">
    <base-button v-if="selectedItems.length > 0 && isLocationFiltered === false" :loading="isDeleting" type="primary" class="tw-justify-self-end tw-mb-3" @click="bulkDelete"
      >Delete {{ selectedItems.length }} Activities</base-button
    >
    <base-table ref="todoItems" :loading="isLoading" :fields="fields" :items="items" :overflowVisible="false" @checked="selectAll">
      <template v-if="isLocationFiltered === false" #actionBox="{item: todoItem}">
        <base-checkbox :value="todoItem.todoItemId" v-model="selectedItems" />
      </template>
      <template #assignedDate="{item: todoItem}">
        <div class="tw-flex tw-items-center tw-text-sm tw-whitespace-nowrap">
          <div>{{ customDateFormatter(todoItem.assignedDate) }}</div>
        </div>
      </template>
      <template #dueDate="{item: todoItem}">
        <div class="tw-flex tw-items-center tw-text-sm tw-whitespace-nowrap">
          <div v-if="isLocationFiltered === true" :class="'tw-text-' + dueDateColor(todoItem.dueDate) + '-500'">{{ dueDateFormatter(todoItem.dueDate) }}</div>
          <base-button v-else type="text" :color="dueDateColor(todoItem.dueDate)" @click="editDueDate(todoItem)">
            {{ dueDateFormatter(todoItem.dueDate) }}
          </base-button>
        </div>
      </template>
      <template #todoItem="{item: todoItem}">
        <div class="tw-flex">
          <div>
            <div class="tw-flex tw-flex-col tw-items-start">
              <div class="tw-flex tw-font-normal tw-text-gray-700 tw-text-base tw-whitespace-nowrap">{{ todoItem.todoItemTypeLabel }}</div>
              <div class="tw-flex tw-font-normal tw-text-xs tw-whitespace-nowrap">
                <base-button type="text" size="md" @click="gotoMember(todoItem.userId)">{{ todoItem.userName }}</base-button>
              </div>
              <div v-if="todoItem.businessLocationName != null" class="tw-flex tw-text-xs tw-text-gray-500 tw-whitespace-nowrap">{{ todoItem.businessLocationName }}</div>
              <base-button v-else type="text" size="xs" color="red" @click="assignLocation(todoItem)">No Location Associated</base-button>
              <div v-if="todoItem.programName != null" class="tw-flex tw-text-xs tw-text-gray-500 tw-whitespace-nowrap">{{ todoItem.programName }}</div>
              <div v-if="todoItem.userBusinessPlanName != null" class="tw-flex tw-text-xs tw-text-gray-500 tw-whitespace-nowrap">{{ todoItem.userBusinessPlanName }}</div>
            </div>
          </div>
        </div>
      </template>
      <template #assigned="{item: todoItem}">
        <assigned-user-button :todoItem="todoItem" :businessUsers="businessUsers" @assign="assign" />
      </template>
      <template #contact="{item: todoItem}">
        <div class="tw-flex-col tw-items-start">
          <base-button v-if="todoItem.userPhoneNumber" type="flat" size="xs" @click="call(todoItem.user.PhoneNumber)">
            <template v-slot:icon>
              <phone-icon />
            </template>
            <base-phone-number-field class="tw-hidden lg:tw-block" :value="todoItem.userPhoneNumber" />
          </base-button>
          <base-button v-if="todoItem.userEmailAddress" type="flat" size="xs" @click="email(todoItem.userEmailAddress)">
            <template v-slot:icon>
              <mail-icon />
            </template>
            <span class="tw-hidden lg:tw-block">{{ todoItem.userEmailAddress }}</span>
          </base-button>
        </div>
      </template>
      <template #actions="{item: todoItem}">
        <div class="tw-flex tw-justify-start tw-space-x-1">
          <base-button type="flat" size="sm" @click="history(todoItem.todoItemId)">
            <template v-slot:icon>
              <list-icon />
            </template>
            Details<base-badge v-show="todoItem.numComments > 0" class="tw-absolute tw--right-2 tw--top-0.5" color="primary" size="xs">{{ todoItem.numComments }}</base-badge>
          </base-button>
          <base-button v-if="showReplyAction(todoItem)" type="flat" size="sm" @click="comment(todoItem.todoItemId, todoItem.todoItemTypeConstant)">
            <template v-slot:icon>
              <comment-icon />
            </template>
            Reply
          </base-button>
          <base-button v-if="showCommentAction(todoItem)" type="flat" size="sm" @click="comment(todoItem.todoItemId, todoItem.todoItemTypeConstant)">
            <template v-slot:icon>
              <edit-icon />
            </template>
            Comment
          </base-button>
          <base-button v-if="showCompleteAction(todoItem)" type="flat" size="sm" @click="complete(todoItem.todoItemId)">
            <template v-slot:icon>
              <check-icon />
            </template>
            Complete
          </base-button>
          <base-button v-if="showDeleteAction()" type="flat" size="sm" @click="del(todoItem.todoItemId)">
            <template v-slot:icon>
              <trash-icon />
            </template>
            Delete
          </base-button>
          <base-button v-if="showRefillAuthApproveAction(todoItem)" type="flat" size="sm" @click="approveChanges(todoItem)">
            <template v-slot:icon>
              <check-icon />
            </template>
            Approve
          </base-button>
          <base-button v-if="showRefillAuthDenyAction(todoItem)" type="flat" color="red" size="sm" @click="deny(todoItem.todoItemId)">
            <template v-slot:icon>
              <x-icon />
            </template>
            Deny
          </base-button>
          <base-button v-if="showClarifyAction(todoItem)" type="flat" size="sm" @click="clarify(todoItem)">
            <template v-slot:icon>
              <question-icon />
            </template>
            Clarify
          </base-button>
        </div>
      </template>
      <template #empty-state>
        <div class="tw-flex tw-justify-center tw-py-5">
          No Results
        </div>
      </template>
      <template #loading-row>
        <td v-if="isLocationFiltered === false" class="tw-py-3 tw-px-4"><base-skeleton-loader class="tw-h-4 tw-w-4" /></td>
        <td class="tw-py-3 tw-px-4"><base-skeleton-loader class="tw-h-6 tw-w-12" /></td>
        <td class="tw-py-3 tw-px-4"><base-skeleton-loader class="tw-h-6 tw-w-12" /></td>
        <td class="tw-py-3 tw-px-4"><base-skeleton-loader class="tw-h-6 tw-w-24" /></td>
        <td class="tw-py-3 tw-pl-4 tw-pr-8"><base-skeleton-loader class="tw-h-4 tw-w-40" /><base-skeleton-loader class="tw-h-2 tw-w-20 tw-mt-2" /></td>
        <td class="tw-py-3 tw-px-4">
          <div class="tw-flex"><base-skeleton-loader class="tw-h-3 tw-w-3 tw-mr-1" /><base-skeleton-loader class="tw-h-3 tw-w-20" /></div>
          <div class="tw-flex tw-mt-2"><base-skeleton-loader class="tw-h-3 tw-w-3 tw-mr-1" /><base-skeleton-loader class="tw-h-3 tw-w-24" /></div>
        </td>
        <td class="tw-py-3 tw-px-4">
          <div class="tw-flex tw-space-x-2 tw-justify-center">
            <base-skeleton-loader class="tw-h-8 tw-w-20" v-for="key in 4" :key="`action-loader-cell-${key}`" />
          </div>
        </td>
      </template>
    </base-table>
    <base-pagination v-if="page.total > page.take" v-model="page" class="tw-mt-2" />
    <approve-rx-auth-with-changes ref="approveChangesSlideover" :businessId="businessId" @save="loadPage" />
    <clarification ref="clarificationSlideover" :businessId="businessId" @save="loadPage" />
    <edit-due-date ref="editDueDateSlideover" :businessId="businessId" @save="modifyLocalDueDate" />
  </div>
</template>

<script>
import moment from "moment";
import { PhoneIcon, MailIcon, CheckIcon, EditIcon, TrashIcon, ListIcon, CommentIcon, XIcon, QuestionIcon } from "@/assets/svgs";
import { mapGetters } from "vuex";
import AssignedUserButton from "@/views/business/todo/components/AssignedUserButton";
import ApproveRxAuthWithChanges from "@/views/business/todo/components/ApproveRxAuthWithChanges";
import Clarification from "@/views/business/todo/components/Clarification";
import EditDueDate from "@/views/business/todo/components/EditDueDate";
import { debounce } from "debounce";

const TAKE_KEY = "predictile_todo_items_take";

export default {
  name: "ItemsList",
  props: {
    businessId: String,
    category: String,
    showRows: { type: Number, default: 10 },
    query: String,
    filters: Object,
    targetEntityId: String,
  },
  components: {
    PhoneIcon,
    MailIcon,
    CheckIcon,
    EditIcon,
    TrashIcon,
    QuestionIcon,
    AssignedUserButton,
    ListIcon,
    CommentIcon,
    XIcon,
    ApproveRxAuthWithChanges,
    Clarification,
    EditDueDate,
  },
  data() {
    return {
      isLoading: true,
      isDeleting: false,
      page: {
        take: localStorage.getItem(TAKE_KEY) ? +localStorage.getItem(TAKE_KEY) : 50,
        skip: 0,
        total: 0,
      },
      businessUsers: [],
      items: [],
      selectedItems: [],
    };
  },
  computed: {
    fields() {
      let fields = [];

      if (this.isLocationFiltered === false) fields.push({ title: "", key: "actionBox", thClass: "tw-w-0 tw-text-left", isCheckbox: true });

      fields.push(
        { title: "Assigned Date", key: "assignedDate", thClass: "tw-w-0 tw-text-left tw-whitespace-nowrap" },
        { title: "Due Date", key: "dueDate", thClass: "tw-w-0 tw-text-left tw-whitespace-nowrap" },
        { title: "Assigned to", key: "assigned", thClass: "tw-w-0 tw-text-left tw-whitespace-nowrap" },
        { title: "Activity", key: "todoItem", thClass: "tw-w-0 tw-text-left" },
        { title: "Contact", key: "contact", thClass: "tw-w-0 tw-text-left" },
        { title: "Actions", key: "actions", thClass: "tw-w-0 tw-text-center" },
      );
      return fields;
    },
    ...mapGetters("cognito", { userId: "id" }),
    ...mapGetters("role", { isLocationFiltered: "isLocationFiltered" }),
    url() {
      if (this.category === "assigned") return `/businesses/${this.businessId}/todo/assigned`;
      else if (this.category === "unassigned") return `/businesses/${this.businessId}/todo/unassigned`;
      else if (this.category === "completed") return `/businesses/${this.businessId}/todo/completed`;
      else if (this.category === "assigned-self") return `/businesses/${this.businessId}/todo/assigned-self`;
      else return `/businesses/${this.businessId}/todo/open`;
    },
  },
  watch: {
    page(newValue) {
      localStorage.setItem(TAKE_KEY, newValue.take);
      this.loadPage();
    },
    query() {
      this.page.skip = 0;
      this.debouncedLoadPage();
    },
    filters: function(newValue, oldValue) {
      if (newValue !== oldValue) this.loadPage();
    },
  },
  created() {
    this.loadPage();
    this.loadBusinessUsers();
    this.debouncedLoadPage = debounce(this.loadPage, 500);
    this.EventBus.$on("selectAllTodo", this.selectAll);
  },
  mounted() {
    this.EventBus.$on("activitiesUpdated", this.loadPage);
  },
  methods: {
    refresh() {
      this.loadPage();
    },
    next() {
      this.page.skip += this.page.take;
    },
    previous() {
      this.page.skip -= this.page.take;
    },
    showReplyAction(todoItem) {
      return todoItem.todoItemTypeConstant === "ONLINE_SUPPORT_QUESTION" && todoItem.status !== "completed";
    },
    showCommentAction(todoItem) {
      return (
        todoItem.status !== "completed" &&
        todoItem.todoItemTypeConstant !== "ONLINE_SUPPORT_QUESTION" &&
        todoItem.todoItemTypeConstant !== "RX_AUTHORIZATION" &&
        this.isLocationFiltered === false
      );
    },
    showCompleteAction(todoItem) {
      return (
        todoItem.status !== "completed" &&
        todoItem.todoItemTypeConstant !== "RX_AUTHORIZATION" &&
        todoItem.todoItemTypeConstant !== "PRESCRIBER_CLARIFICATION" &&
        !this.isLocationFiltered
      );
    },
    showDeleteAction() {
      return this.isLocationFiltered === false;
    },
    showRefillAuthApproveAction(todoItem) {
      return todoItem.status !== "completed" && this.isLocationFiltered === true && todoItem.todoItemTypeConstant === "RX_AUTHORIZATION";
    },
    showRefillAuthDenyAction(todoItem) {
      return todoItem.status !== "completed" && this.isLocationFiltered === true && todoItem.todoItemTypeConstant === "RX_AUTHORIZATION";
    },
    showClarifyAction(todoItem) {
      return todoItem.status !== "completed" && this.isLocationFiltered === true && todoItem.todoItemTypeConstant === "PRESCRIBER_CLARIFICATION";
    },
    getUser(userId) {
      if (userId && this.businessUsers.length > 0) return this.businessUsers.find((u) => u.userId === userId).initials;
      else return "";
    },
    call(phoneNumber) {
      window.open("tel:" + phoneNumber);
    },
    email(emailAddress) {
      window.open("mailto:" + emailAddress);
    },
    del(item) {
      this.$emit("del", item);
    },
    comment(item, constant) {
      this.$emit("comment", { todoItemId: item, constant: constant });
    },
    history(item) {
      this.$emit("history", item);
    },
    assign(item) {
      this.$emit("assign", item);
    },
    assignLocation(item) {
      this.$emit("assign-location", item);
    },
    approveChanges(item) {
      this.$refs.approveChangesSlideover.show(item.todoItemId, item.userId, item.businessPrescriptionId);
    },
    clarify(item) {
      this.$refs.clarificationSlideover.show(item.todoItemId, item.userId, item.businessPrescriptionId);
    },
    deny(item) {
      this.$emit("deny", item);
    },
    editDueDate(item) {
      this.$refs.editDueDateSlideover.show(item.todoItemId, item.dueDate);
    },
    loadPage() {
      this.isLoading = true;

      let url = `/businesses/${this.businessId}/todo/search`;
      url += `?skip=${this.page.skip}&take=${this.page.take}&query=${encodeURIComponent(this.query || "")}`;

      if (this.targetEntityId != null) url += `&targetUserId=${this.targetEntityId}`;

      let filters = { locationsFilter: [], typesFilter: [], assignedToFilter: [], startDate: null, endDate: null };
      if (this.filters !== undefined) filters = this.filters;

      this.$axios
        .post(url, {
          tab: this.category,
          targetUserId: this.targetEntityId,
          locationsFilter: filters.locationsFilter,
          typesFilter: filters.typesFilter,
          assignedToFilter: filters.assignedToFilter,
          startDate: filters.startDate,
          endDate: filters.endDate,
        })
        .then((res) => {
          this.page.take = res.data.take;
          this.page.skip = res.data.skip;
          this.page.total = res.data.total;
          this.items = res.data.items;
        })
        .catch((err) => {
          this.EventBus.$emit("GLOBAL_ERROR", {
            title: "Failed to load tasks",
            message: "We had a problem retrieving the list of tasks. Please reload the page to try again.",
            error: err,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    loadBusinessUsers() {
      this.$axios.get(`/businesses/${this.businessId}/users/all`).then((res) => {
        this.businessUsers = res.data;
      });
    },
    complete(todoItemId) {
      this.isLoading = true;

      this.$axios
        .put(`/businesses/${this.businessId}/todo/${todoItemId}`, {
          status: "completed",
        })
        .then(() => {
          this.EventBus.$emit("GLOBAL_NOTIFY", {
            title: "Activity Completed",
            message: `Your activity was marked complete.`,
          });
          this.loadPage();
        })
        .catch((err) => {
          this.EventBus.$emit("GLOBAL_ERROR", {
            title: "Error completing activity",
            message: "Sorry, we had trouble completing this activity. The technicians have been notified. Please try again.",
            error: err,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    customDateFormatter(date) {
      if (date == null) return "";

      return moment
        .utc(date)
        .local()
        .format("MM/DD/YY");
    },
    dueDateFormatter(date) {
      if (date == null) return "";

      return moment(date).format("MM/DD/YY");
    },
    dueDateStatus(date) {
      if (moment(date).isSame(new Date(), "day")) return "today";
      else if (moment(date).diff(new Date(), "days") > 0) return "future";
      else return "overdue";
    },
    dueDateColor(date) {
      if (moment(date).isSame(new Date(), "day")) return "yellow";
      else if (moment(date).diff(new Date(), "days") > 0) return "primary";
      else return "red";
    },
    gotoMember(memberId) {
      this.$router.push(`/businesses/${this.businessId}/members/${memberId}/plans`);
    },
    modifyLocalDueDate(eventData) {
      const item = this.items.find((i) => i.todoItemId === eventData.todoItemId);
      if (item) item.dueDate = eventData.dueDate;
    },
    selectAll(e) {
      if (e.length === 0) this.selectedItems = [];
      else this.selectedItems = this.items.map((i) => i.todoItemId);
    },
    bulkDelete() {
      if (this.selectedItems.length > 0) {
        this.isDeleting = true;

        this.$axios
          .post(`/businesses/${this.businessId}/todo/bulk-delete`, { deletionIds: this.selectedItems })
          .then(() => {
            this.EventBus.$emit("GLOBAL_NOTIFY", {
              title: `${this.selectedItems.length} Activites Deleted`,
              message: `Your activities were deleted.`,
            });
            this.loadPage();
            this.selectedItems = [];
            this.$refs.todoItems.clearChecked();
          })
          .catch((err) => {
            this.EventBus.$emit("GLOBAL_ERROR", {
              title: "Error deleting activities",
              message: "Sorry, we had trouble deleting these activities. The technicians have been notified. Please reload the page and try again.",
              error: err,
            });
          })
          .finally(() => {
            this.isDeleting = false;
          });
      }
    },
  },
};
</script>
